import { graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import styled from "styled-components";
import { H5, IconCaret, P } from "@upsolve/ui";

import richTextNodeToComponent from "../Contentful/richTextNodeToComponent";

const HomePageFAQItem = ({ question }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div key={question.id} className="faq__question" onClick={() => setIsOpen(!isOpen)}>
      <div className={`faq__question__header ${isOpen ? "opened" : ""}`}>
        <H5 as="label">{question.text.text}</H5> <IconCaret />
      </div>
      {isOpen && (
        <div className="faq__question__text">
          {question.answers.map((answer) => (
            <div key={answer.id}>{richTextNodeToComponent(JSON.parse(answer.text.text))}</div>
          ))}
        </div>
      )}
    </div>
  );
};

const HomePageFAQ = () => {
  const { faq } = useStaticQuery(graphql`
    query HomePageFAQQuery {
      faq: contentfulFaqHcj(title: { eq: "homepage-faq" }) {
        questions {
          id
          text {
            text
          }
          answers {
            id
            text {
              text
            }
          }
        }
      }
    }
  `);
  return (
    <StyledHomePageFAQ>
      {faq.questions.map((question) => (
        <HomePageFAQItem key={question.id} question={question} />
      ))}
    </StyledHomePageFAQ>
  );
};

const StyledHomePageFAQ = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 2em 1em;
  .faq__question {
    background: white;
    border-radius: 4px;
    overflow: hidden;
    margin: 0.5em 0;
    &__header {
      padding: 1.25em 2em;
      border-bottom: 2px solid ${(props) => props.theme.colors.white[500]};
      color: ${(props) => props.theme.colors.brand[500]};
      display: flex;
      justify-content: space-between;
      align-items: center;
      label {
        color: ${(props) => props.theme.colors.brand[500]};
        line-height: 125%;
      }
      svg {
        transition: 250ms;
        height: 16px;
        width: 16px;
        min-width: 16px;
        margin-left: 10px;
        path {
          fill: ${(props) => props.theme.colors.brand[500]};
        }
      }
      &.opened {
        svg {
          transform: rotate(180deg);
        }
      }
      &:hover,
      label:hover,
      svg:hover {
        cursor: pointer;
      }
      @media screen and (max-width: 45em) {
        padding: 1em 1em;
      }
    }
    &__text {
      padding: 0 2em 1.25em;
      border-bottom: 2px solid ${(props) => props.theme.colors.white[500]};
      ul,
      ol {
        padding: 0 0 0 2em;
      }
      ul {
        list-style-type: initial;
      }
      @media screen and (max-width: 45em) {
        padding: 1em 1em;
      }
    }
  }
`;

export default HomePageFAQ;
